import React, { useMemo, useState } from 'react'
import styled from 'styled-components'
import { Oval } from 'react-loader-spinner'
import { openVideoList } from '../../helpers/service'

import { useLexicon } from '../../hooks/useLexicon'
import { extractFirstCharacters, getPlayerParamMarkers } from '../../helpers'
import { $apiV1, $apiV2 } from '../../config/api'
import { breakpoints } from '../../style/size'
import useOutsideClick from '../../hooks/useOutsideClick'

//images
import starOn from "../../images/star_on.svg";
import starOff from "../../images/star_off.svg";
import emptyState from "../../images/contactLogo.svg";
import emptySearch from "../../images/ic_empty.svg";
import { ReactComponent as SortAscIcon } from "../../images/icons/sortasc_icon.svg";
import { ReactComponent as SortDescIcon } from "../../images/icons/sort_desc.svg";
import { ReactComponent as SortDefaultIcon } from "../../images/icons/sort_default.svg";
import more from "../../images/ic_more.svg";
import compareBtn from "../../images/ic_compare.svg";
import compareBlue from "../../images/compare_blue.svg";
import searchIcon from "../../images/ic_search.svg";

//components
import { Pagination } from '../ui'
import { Action, MatchContent, MatchInfo } from '../../style/MatchTable'
import { NotificationList } from '../notification/NotificationList'
import { useNotification } from '../notification/useNotification'
import { EmptyState } from '../../style/Tournaments'
import { getMediaUrl } from '../../helpers'

export const TableContainer = styled.div`
    max-height: 66vh;
    overflow-x: auto;
    scrollbar-width: auto;
`

export const Table = styled.table`
    // width: 100%;
    min-width: fit-content;
    table-layout: fixed;
    text-align: center;
    width: max-content;
    border-collapse: collapse;

    tr, td, th {
        font-family: "SatoshiMedium";
    }

    .values {
        color: ${(props) => props.theme.white};
    }

    tr {
        border-bottom: 1px solid #272727;
    }

    .sticky {
        position: sticky;
        // z-index: 1;
        background: ${(props) => props.theme.black};
    }

    .sticky.name {
        left: 0px;
        width: ${(props) => props.type === 'default' ? "356px" : "176px"};
        min-width: ${(props) => props.type === 'default' ? "356px" : "176px"};
    }

    .sticky.season {
        left: ${(props) => props.type === 'default' ? "356px" : "195px"};
    }

    td, th {
        min-width: 100px;
        width: 100px;
    }

    td.values span {
        color: ${(props) => props.theme.white};
        font-family: "SatoshiMedium";
        font-size: 16px;
        font-weight: 500;
        font-style: Medium;
    }

    .tr-colored {
        background: ${(props) => props.theme.row};
    }
`

export const ThTable = styled.thead`
    // line-height: 41px;
    position: sticky;
    // text-transform: uppercase;
    top: 0;
    z-index: 1;
    font-family: "SatoshiMedium";
    font-size: 12px;

    tr {
        background: ${(props) => props.theme.black};
    }
`

export const ThTableItem = styled.th`
    color: ${(props) => props.theme.white};
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0.5px;
    text-align: center;
    line-height: 18px;
    cursor: pointer;
`

const PlayerWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 20px;
`

const PlayerAvatar = styled.div`
    position: relative;

    .avatar {
        width: 40px;
        height: 40px;
        object-fit: cover;
        cursor: pointer;
    }

    .flag {
        position: absolute;
        object-fit: cover;
        top: -5px;
        right: -5px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
    }
`

const PlayerInfoWrapper = styled.div`
    display: flex;
    gap: 6px;
    flex-direction: column;
    position: relative;
    text-align: left;

    h3 {
        line-height: 0;
        margin-bottom: 8px;

        span {
            color: rgba(115, 128, 137, 1);
            font-family: "SatoshiMedium";
            font-size: 12px;
            font-weight: 500;
            font-style: Medium;
            letter-spacing: 0px;
            text-align: left;
        }
    }

    h4, .smrtSearchPosition {
        opacity: 1;
        color: ${(props) => props.theme.white};
        font-family: "SatoshiMedium";
        font-size: 16px;
        font-weight: 500;
        font-style: Medium;
        letter-spacing: 0px;
        text-align: left;
        line-height: 24px;
        max-width: 15vw;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        @media only screen and (${breakpoints.mobile}) {
        max-width: 150px;
        }
    }

    .smrtSearchPlayer:hover {
        text-decoration: underline;
        cursor: pointer;
    }

    .smrtSearchPosition {
        font-size: 13px;
        margin-bottom: 0px;
    }

    .teamSmrtSearch {
        display: flex;
        align-items: center;
        gap: 5px;
        font-family: "SatoshiBold";
        font-size: 13px;
        font-weight: 700;
        font-style: Bold;
        max-width: 19vw;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &:hover {
            cursor: pointer;
            text-decoration: underline;
        }
  }
`

const PlayerMenu = ({ data, addNotification }) => {
    const l = useLexicon();

    const [openRow, setOpenRow] = useState(false);
    const [successPopup, setSuccessPopup] = useState(false);

    const menuDropdownRef = useOutsideClick(() => {
        if (openRow) {
            setOpenRow(false);
        }
    });

    const handleCompare = async (item) => {
        try {
            await $apiV2.post(`/platform/compare/add`, {
                player_id: item.id,
            });

            addNotification(`${l(1046)}`, 'info')
            setSuccessPopup(!successPopup);
        } catch (error) {
            console.error("Error adding player to compare list:", error);
        }
    };

    return (
        <>
            <div ref={menuDropdownRef} style={{ position: 'absolute', right: 20 }}>
                <img
                    style={{ cursor: 'pointer' }}
                    className="more "
                    src={more}
                    alt={more}
                    onClick={() => setOpenRow(prev => !prev)}
                />
                {openRow && (
                    <MatchInfo className="smrtSearchInfo">
                        <MatchContent>
                            <Action
                                onClick={() =>
                                    window.open(
                                        `/tournaments/player/${data.id}`,
                                        "_blank"
                                    )
                                }
                            >
                                <img src={searchIcon} alt={"See more"} />
                                <h4>{l(963)}</h4>
                            </Action>
                            <Action onClick={() => handleCompare(data)}>
                                <img
                                    src={
                                        localStorage.getItem("theme") === "light"
                                            ? compareBlue
                                            : compareBtn
                                    }
                                    alt={"Compare"}
                                />
                                <h4>{l(1008)}</h4>
                            </Action>
                        </MatchContent>
                    </MatchInfo>
                )}
            </div>
        </>
    )
}

export const SmrtSearchTableNew = React.memo((props) => {
    const {
        data,
        loading,
        totalPlayers,
        page,
        handlePageChange,
        handleSortTable,
        tableTypeSorting,
        typeShowData = 1,
    } = props;
    const { notifications, addNotification, removeNotification } = useNotification();

    const l = useLexicon();

    const [favoritePlayers, setFavoritePlayers] = useState([]);

    const tableHeadNames = useMemo(() => {
        if (data?.length > 0) {
            const result = Object.values(data?.[0]?.params)?.[0];
            return result;
        }

        return [];
    }, [data]);

    const toggleFavorite = async (item) => {
        try {
            const isCurrentlyFavorite = favoritePlayers[item.id] ?? false;

            if (isCurrentlyFavorite) {
                await $apiV1.delete(`/users/favorites/players/${item.id}/`);
            } else {
                await $apiV1.post(`/users/favorites/players/`, { player: item.id });
            }

            setFavoritePlayers((prev) => ({
                ...prev,
                [item.id]: !isCurrentlyFavorite,
            }));
        } catch (error) {
            console.error("Error toggling favorite status:", error);
        }
    };


    const handleClickPlayerParam = async (param, player) => {
        const { parameter_id, parameter_name, lexic_id, year_season_id, season_id } = param;
        const { id, name, surname } = player;
        try {
            const controller = new AbortController();
            addNotification(`Fetching clips. Please don't close or refresh the page till the download is completed.`, "info", controller);
            document.body.classList.add("loading-cursor");
            const data = await getPlayerParamMarkers(
                id,
                parameter_id,
                year_season_id,
                controller,
                1,
                season_id
            );
            if (data?.results?.length > 0) {
                const markers = data.results.map((item) => item.id).join(",");
                openVideoList(markers, `${l(lexic_id) || parameter_name} - ${name} ${surname}`, true);
            } else {
                addNotification(
                    `There are 0 clips in the response from the server.`,
                    "warning"
                );
            }
        } catch (e) {
            console.log("error get param markers", e);
            if (e.type === "canceled") {
                addNotification(
                    `The request to receive clips of the player has been canceled.`,
                    "warning"
                );
                return;
            }
            addNotification(`Error in receiving player clips.`, "error");
        } finally {
            document.body.classList.remove("loading-cursor");
        }
    };

    const isCanClickPlayerStat = (parameter) => {
        return (
            parameter?.count?.total === 0 ||
            parameter?.markers?.length === 0 ||
            parameter.parameter_name.includes("%") ||
            parameter.parameter_name.includes("Mins Played")
        );
    };

    return (
        <>
            <Oval
                secondaryColor={
                    localStorage.getItem("theme") === "light" ? "#4E5255" : "#CFDAE6"
                }
                wrapperStyle={{
                    width: "100%",
                    height: "60vh",
                    alignItems: "center",
                    justifyContent: "center",
                    display: loading ? 'flex' : 'none'
                }}
            />
            <TableContainer style={{ marginBottom: 20, display: data?.length > 0 && !loading ? 'flex' : 'none' }}>
                <Table type="default">
                    <ThTable>
                        <tr>
                            <th className='sticky name'>{l(319)}</th>
                            <th className='sticky season'>{l(453)}</th>
                            {tableHeadNames?.map(item => (
                                <ThTableItem
                                    title={`${l(item.lexic_id) || item.parameter_name}`}
                                    key={item.parameter_id}
                                    onClick={() => handleSortTable(item)}
                                >
                                    {extractFirstCharacters(l(item.lexic_id) || item.parameter_name)}
                                    {
                                        tableTypeSorting.type === 'asc' && tableTypeSorting.param == item.parameter_id ? (
                                            <SortAscIcon />
                                        ) : tableTypeSorting.type === 'desc' && tableTypeSorting.param == item.parameter_id ? (
                                            <SortDescIcon />
                                        ) : (
                                            <SortDefaultIcon />
                                        )
                                    }
                                </ThTableItem>
                            ))}
                        </tr>
                    </ThTable>
                    <tbody>
                        {data?.map((row, i) => {
                            const { params, id } = row;
                            const seasons = Object.keys(params);
                            const rowSpan = seasons.length + 1;
                            const isShouldColor = i % 2 === 0;
                            const isFavorite = favoritePlayers[id] ?? false;
                            return (
                                <React.Fragment key={row.id}>
                                    <tr className={isShouldColor ? 'tr-colored' : ''}>
                                        <td className='sticky name' rowSpan={rowSpan}>
                                            <PlayerWrapper>
                                                <img
                                                    src={isFavorite ? starOn : starOff}
                                                    alt="Favorite star"
                                                    style={{
                                                        width: "18px",
                                                        height: "100%",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => toggleFavorite(row)}
                                                />
                                                <PlayerAvatar>
                                                    <img
                                                        className='avatar'
                                                        onClick={() =>
                                                            window.open(
                                                                `/tournaments/player/${row.id}`,
                                                                "_blank"
                                                            )
                                                        }
                                                        onContextMenu={() =>
                                                            window.open(
                                                                `/tournaments/player/${row.id}`,
                                                                "_blank"
                                                            )
                                                        }
                                                        src={
                                                            row.photos.length > 0
                                                                ? getMediaUrl(row.photos.find((photo) => photo.full).full)
                                                                : emptyState
                                                        }
                                                        onError={(e) => {
                                                            e.target.src = emptyState;
                                                        }}
                                                        alt={"Player"}
                                                    />
                                                    {row?.nationality?.length > 0 && (
                                                        <img
                                                            className="flag"
                                                            src={
                                                                getMediaUrl(row?.nationality?.find((flag) => flag.flag)
                                                                    ?.flag)
                                                            }
                                                            alt={"Flag"}
                                                            onError={(e) => {
                                                                e.target.src = emptyState;
                                                            }}
                                                        />
                                                    )}
                                                </PlayerAvatar>

                                                <PlayerInfoWrapper>
                                                    <h3>
                                                        <span>{l(327)} {row?.age},&nbsp;</span>
                                                        <span>{l(113)} {row?.height} cm,&nbsp;</span>
                                                        <span>{row?.leg}</span>
                                                    </h3>
                                                    <h4
                                                        className="smrtSearchPlayer"
                                                        title={row.display_name || `${row.name} ${row.surname}`}
                                                        onClick={() =>
                                                            window.open(
                                                                `/tournaments/player/${row.id}`,
                                                                "_blank"
                                                            )
                                                        }
                                                        onContextMenu={() =>
                                                            window.open(
                                                                `/tournaments/player/${row.id}`,
                                                                "_blank"
                                                            )
                                                        }
                                                    >
                                                        {row.display_name || `${row.name} ${row.surname}`}
                                                    </h4>
                                                    <h3
                                                        className="smrtSearchPosition"
                                                        title={row.position
                                                            ?.map((pos) => (l(pos.name)))
                                                            ?.join("\r\n") || 'No position'}
                                                    >
                                                        {row.position
                                                            ?.map((pos) => (l(pos.lexic_id)))
                                                            ?.join(", ") || 'No position'}
                                                    </h3>
                                                    <span
                                                        title={row?.team?.name}
                                                        className="teamSmrtSearch"
                                                        onClick={() =>
                                                            row?.team?.id &&
                                                            window.open(
                                                                `/tournaments/team/${row.team?.id}`,
                                                                "_blank"
                                                            )
                                                        }
                                                        onContextMenu={() =>
                                                            row?.team?.id &&
                                                            window.open(
                                                                `/tournaments/team/${row.team?.id}`,
                                                                "_blank"
                                                            )
                                                        }
                                                    >
                                                        <img
                                                            style={{
                                                                width: "20px",
                                                                height: "20px",
                                                                objectFit: "contain",
                                                            }}
                                                            src={getMediaUrl(row?.team?.logo)}
                                                            onError={(e) => {
                                                                e.target.src = emptyState;
                                                            }}
                                                            alt={"Team logo"}
                                                        />
                                                        {row?.team?.name}
                                                    </span>
                                                </PlayerInfoWrapper>
                                                <PlayerMenu data={row} addNotification={addNotification} />
                                            </PlayerWrapper>
                                        </td>
                                    </tr>
                                    {seasons.flatMap((season, index) => {
                                        const seasonData = params[season];
                                        return (
                                            <tr
                                                key={`${season}-${index}`}
                                                className={isShouldColor ? 'tr-colored' : ''}
                                            >
                                                <td className='sticky season'>{season}</td>
                                                {seasonData.map((param, idx) => {
                                                    const value = typeShowData === 1 ? param?.count?.total : param?.count?.avg_matches;
                                                    const isCanClickParam = isCanClickPlayerStat(param);
                                                    return (
                                                        <td
                                                            className='values'
                                                            key={`${param.parameter_id}-${idx}`}
                                                            style={
                                                                isCanClickParam
                                                                    ? { cursor: "not-allowed" }
                                                                    : { cursor: "pointer" }
                                                            }
                                                            onClick={() =>
                                                                !isCanClickParam &&
                                                                handleClickPlayerParam(param, row)
                                                            }
                                                            onContextMenu={(e) => {
                                                                e.preventDefault()
                                                                !isCanClickParam &&
                                                                    handleClickPlayerParam(param, row)
                                                            }

                                                            }
                                                        >
                                                            {value}
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                        )
                                    })}
                                </React.Fragment>
                            )
                        })}
                    </tbody>
                </Table>
            </TableContainer>
            <EmptyState style={{ display: data?.length === 0 && !loading ? 'flex' : 'none', height: '50vh' }}>
                <img src={emptySearch} alt={emptySearch} />
                <h3>{l(1048)}</h3>
            </EmptyState>
            <Pagination
                disabled={loading || data.length === 0}
                items={totalPlayers}
                itemsPerPage={10}
                page={page - 1 || 0}
                onPageChange={handlePageChange}
            />
            <NotificationList
                notifications={notifications}
                onClose={removeNotification}
            />
        </>
    )
})